import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number | undefined;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, type, duration = 5000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getToastStyles = () => {
    switch (type) {
      case 'success':
        return 'bg-theme-accent text-white';
      case 'error':
        return 'bg-[var(--theme-danger)] text-white';
      case 'warning':
        return 'bg-[var(--theme-warning)] text-black';
      case 'info':
        return 'bg-[var(--theme-info)] text-white';
      default:
        return 'bg-[var(--theme-text-muted)] text-white';
    }
  };

  return (
    <div className={`fixed top-4 right-4 z-[200] px-6 py-3 rounded-lg shadow-lg ${getToastStyles()} max-w-sm`}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">{message}</span>
        <button
          onClick={onClose}
          className="ml-4 text-white hover:text-white/70 focus:outline-none"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;
